module.exports = __webpack_public_path__ + "img/gw.50cec7fd.svg";